import { render } from "./approval.vue?vue&type=template&id=715a1fc1&scoped=true&ts=true"
import script from "./approval.vue?vue&type=script&lang=ts"
export * from "./approval.vue?vue&type=script&lang=ts"

import "./approval.vue?vue&type=style&index=0&id=715a1fc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715a1fc1"]])

export default __exports__